import { makeStyles } from "@material-ui/core/styles";

type SidebarStylesProps = {
  collapsed: boolean;
};

export function useSidebarStyles({ collapsed }: SidebarStylesProps) {
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: 0,
      color: "#FFF",
      backgroundColor: "#004B97",
      width: collapsed ? 75 : 272,
      minWidth: collapsed ? 75 : 272,
      transition: "all 0.2s ease-in-out",
      overflow: "hidden",
    },
    header: {
      width: "100%",
      maxWidth: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: collapsed ? 12 : "0px 16px",
    },
    menuButton: {
      borderRadius: 5,
    },
    logo: {
      maxWidth: 170,
    },
    list: {
      padding: 12,
      color: "#FFF",
      backgroundColor: "#004B97",
    },
    listItem: {
      gap: ".8rem",
      display: "flex",
      padding: 16,
      borderRadius: 5,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: "#FFF",
      "&:hover": {
        textDecoration: "none",
      },
    },
    listItemIcon: {
      minWidth: 0,
      width: 24,
      height: 24,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
